(function() { window.GUID_629faa74_4e43_4926_876d_cd31c0f5ce4b = { getGuid: function() { return "629faa74-4e43-4926-876d-cd31c0f5ce4b"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class BindedElementHelper {
            constructor($parentControl) {
                this.$parentControl = $parentControl;
                this.FindJQueryElement();
            }
            FindJQueryElement() {
                let jquerySelectors = this.$parentControl.data('bindedelementjqueryselectors');
                if (jquerySelectors != null) {
                    if (jquerySelectors.lastIndexOf(',') == jquerySelectors.length - 1) {
                        jquerySelectors = jquerySelectors.substring(0, jquerySelectors.length - 1);
                    }
                    this.bindedElements = CS.DOM.$body.find(jquerySelectors);
                }
            }
            PrepareData(data) {
                if (this.bindedElements != null) {
                    if (data == null) {
                        data = {};
                    }
                    this.bindedElements.each(function () {
                        let $this = $(this);
                        data[$this.attr('name')] = $this.val();
                    });
                }
            }
        }
        Controls.BindedElementHelper = BindedElementHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=binded-elements-helper.pre.js.map
